import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getRecipeImage } from '../../constants';

const RecipeImageRibbon = ({ recipe, recipe_image }) => {
  const theme = useTheme();
  console.log(recipe_image);

  return (
    <Box sx={{
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
      boxShadow: theme.shadows[2],
      mb: 3
    }}>
      <Box
        component="img"
        src={getRecipeImage(recipe_image)}
        alt={recipe?.recipe_name}
        sx={{
          width: '100%',
          height: { xs: 200, sm: 300, md: 400 },
          objectFit: 'cover'
        }}
      />
      
      <Box sx={{
        position: 'absolute',
        top: 10,
        right: -10,
        bgcolor: recipe.recipe_status === 'Draft' ? 'error.main' : 'success.main',
        color: 'white',
        px: 2,
        py: 0.5,
        transform: 'rotate(45deg)',
        boxShadow: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <Typography variant="caption">
          {recipe.recipe_status === 'Draft' ? 'Draft' : 'Public'}
        </Typography>
      </Box>
    </Box>
  );
};

RecipeImageRibbon.propTypes = {
  recipe: PropTypes.shape({
    recipe_name: PropTypes.string,
    recipe_status: PropTypes.string
  }),
  recipe_image: PropTypes.array
};

export default RecipeImageRibbon;
